// This is a placeholder to just put our translations in one place for now until we can actually implement them.

export function translate(translationKey) {
    return englishTranslations[translationKey] || `Missing translation for key: ${translationKey}`;
}

const englishTranslations = {
    settings: 'Settings',
    temperatureUnits: 'Temperature Units',
    windUnits: 'Wind Units',
    pressureUnits: 'Pressure Units',
    forecasts: 'Forecasts',
    doNotSellMyData: 'Do Not Sell/Share My Personal Information',
    notSellingYourData: 'Not Selling/Sharing Your Data',
    copyrightStatementBeginning: 'GroundTruth, ',
    copyrightStatementEnd: '. WeatherBug is a brand of GroundTruth. All Rights Reserved.',
    terms: 'Terms',
    privacy: 'Privacy',
    partners: 'Partners',
    adChoices: 'Ad Choices',
    sitemap: 'Sitemap',
    usa: 'USA',
    loading: 'Loading',
    confirmed: 'Confirmed',
    error: 'Error',
    uvIndex: 'UV Index',
    sunrise: 'Sunrise',
    sunset: 'Sunset',
    moon: 'Moon',
    pressure: 'Pressure',
    windGust: 'Wind Gust',
    wind: 'Wind',
    humidity: 'Humidity',
    averageWind: 'Avg. Wind',
    monthlyRain: 'Monthly Rain',
    dewpoint: 'Dew Point',
    dailyRain: 'Daily Rain',
    windchill: 'Windchill',
    alerts: 'Alerts',
    spark: 'Spark',
    hurricane: 'Hurricane',
    fire: 'Fire',
    notAvailable: 'Not Available',
    low: 'Low',
    moderate: 'Moderate',
    high: 'High',
    veryHigh: 'Very High',
    extreme: 'Extreme',
    weatherDetails: 'WEATHER DETAILS',
    lowMedium: 'Low-Medium',
    medium: 'Medium',
    mediumHigh: 'Medium-High',
    todaysNationalOutlook: 'TODAY\'S NATIONAL OUTLOOK',
    imageFailedToLoad: 'Image failed to load',
    next: 'Next',
    previous: 'Previous',
    maps: 'Maps',
    life: 'Life',
    newsAndVideo: 'News & Videos',
    cameras: 'Cameras',
    airquality: 'Air Quality',
    education: 'Education',
    signin: 'Sign In',
    feedback: 'Feedback',
    careers: 'Careers',
    searchInputPlaceholder: 'Search City or Zip',
    favoriteLocations: 'Favorite Locations',
    manageLocations: 'Manage Locations',
    hi: 'Hi',
    signOut: 'Sign Out',
    readMore: 'Read More',
    thumbnailFailedToLoad: 'Thumbnail failed to load',
    topStories: 'TOP STORIES',
    moreNews: 'MORE NEWS',
    newStoriesNotAvailable: 'News Stories Not Available',
    pollenForecastFor: 'Pollen Forecast for',
    today: 'Today',
    outlook: 'Outlook',
    snowSki: 'Snow & Ski',
    coldFlu: 'Cold & Flu',
    coldAndFlu: 'Cold and Flu',
    coldFluIntro: `Each year, on average 5% to 20% of the U.S. population get sick from seasonal influenza, commonly called "the flu."
        The flu can cause severe illness and life-threatening complications in many people, but can you tell the difference
        between the flu and the common cold?`,
    allergiesAndPollen: 'Allergies & Pollen',
    backTo: 'Back to',
    news: 'News',
    pollen: 'Pollen',
    travel: 'Travel',
    failedToLoadNationalOutlookVideo: 'Failed to load National Outlook Video',
    airQualityTitle: 'Air Quality & Asthma',
    airQualityHeaderTitle: 'Today\'s Condition',
    feelsLike: 'Feels like',
    lo: 'Lo',
    latestNews: 'Latest News',
    viewMore: 'View More',
    topNewsStories: 'Top News Stories',
    footerDevicesMessage: 'Always Have Access to WeatherBug at Your Fingertips, It\'s Free.',
    connectWithUs: 'Connect With Us',
    baseSnow: 'Base Snow',
    newSnow: 'New Snow',
    reportedSnow: 'Reported',
    forecastHigh: 'Forecast High',
    forecastLow: 'Forecast Low',
    resortStatus: 'Resort Status',
    totalLifts: 'Total Lifts',
    openLifts: 'Open LIfts',
    snowCondition: 'Snow Condition',
    snowDepth: 'Snow Depth',
    summitTemp: 'Summit Temp',
    baseTemp: 'Base Temp',
    summitVisibility: 'Summit Visibility',
    baseVisibility: 'Base Visibility',
    summitWindGust: 'Summit Wind Gust',
    baseWindGust: 'Base Wind Gust',
    snowReportTitle: 'SNOW REPORT',
    weatherReportTitle: 'WEATHER REPORT',
    trailsReportTitle: 'TRAILS REPORT',
    liftReportTitle: 'LIFT REPORT',
    elevationTitle: 'ELEVATION',
    serviceInfoTitle: 'SERVICE INFO',
    openTrails: 'Open Trails',
    summit: 'Summit',
    base: 'Base',
    verticalDrop: 'Vertical Drop',
    nordic: 'Nordic',
    skiing: 'Skiing',
    snowPark: 'Snow Park',
    indoorResort: 'Indoor Resort',
    glacierResort: 'Glacier Resort',
    summerActivities: 'Summer Activities',
    yes:'Yes',
    no: 'No',
    of: ' of ',
    featuredVideos: 'Featured Videos',
    moreFeaturedVideos: 'More Featured Videos',
    loadMore: 'Load More',
    free: 'Free',
    storeTextiOS: 'On the App Store',
    storeTextAndroid: 'In Google Play',
    storeTextWindows: 'In Windows store',
    storeTextAmazon: 'In Amazon Appstore',
    get: 'GET',
    weatherbugApp: 'WeatherBug App',
    seeYouGo: 'We’re sorry to see you go.',
    haveAMoment: 'If you have a moment, let us know why you left.',
    thanksForHelping: 'Thank you for your help.',
    moreFeatures: 'I wanted more features',
    notLikeFeel: 'I didn\'t like the look and feel',
    wrongInfo: 'Wrong information displayed',
    longLoadTime: 'Loading time was long',
    iComputerDummy: 'It was not easy to use',
    other: 'Other:',
    yourEmail: 'Your Email:',
    selectOption: 'Please select an option.',
    submit: 'SUBMIT',
    timeLapse: 'Time Lapse',
    hurricaneScreenError: 'Hurricane Map Error - Please refresh to try again',
    allAlertsFor: 'All Alerts For',
    weatherAlertsFor: 'Weather Alerts For',
    sparkAlertsFor: 'Spark Alerts For',
    hurricaneAlertsFor: 'Hurricane Alerts For',
    fireAlertsFor: 'Fire Alerts For',
    pollenAlertsFor: 'Pollen Alerts For',
    airQualityAlertsFor: 'Air Quality Alerts For',
    severeStormRiskAlertsFor: 'Severe Storm Risk Alerts For',
    allAlerts: 'All Alerts',
    weatherAlerts: 'Weather',
    sparkAlerts: 'Spark',
    hurricaneAlerts: 'Hurricane',
    fireAlerts: 'Fire',
    pollenAlerts: 'Pollen',
    airQualityAlerts: 'Air Quality',
    severeStormRiskAlerts: 'Severe Storm Risk',
    pollenLevelsAre: 'Pollen Levels Are',
    aqiIs: 'AQI is',
    cameraUnavailable: 'Camera is not available at this time',
    cameraImageLoadError: 'Failed to load camera image',
    localWeatherCams: 'Local Weather Cams',
    localTrafficCams: 'Local Traffic Cams',
    featuredWeatherCameras: 'Featured Weather Cameras',
    weatherCameraCategories: 'Weather Camera Categories',
    noWeatherCamsInThisRegion: 'No Weather Cams in this region',
    noTrafficCamsInThisRegion: 'No Traffic Cams in this region',
    closestWeatherCameras: 'Closest Weather Cams Nearby',
    cams: 'Cams',
    removeFavorite: 'Remove from Favorite Locations',
    saveFavorite: 'Save to Favorite Locations',
    checkHotelsOn: 'Check Hotels on',
    locations: 'Locations',
    stations: 'Stations',
    enterNewCityOrZipCode: 'Enter New City or Zip Code',
    undo: 'Undo',
    noFavoriteLocationsAddOne: 'No favorite locations. Add one by searching below',
    milesAway: 'Miles Away',
    earthNetworksStations: 'Earth Networks Stations',
    otherStations: 'Other Stations',
    weatherCams: 'Weather Cams',
    trafficCams: 'Traffic Cams',
    videos: 'Videos',
    lifestyles: 'Lifestyles',
    breakingNews: 'BREAKING NEWS',
    errorLoadingHallOfFamePhoto: 'Error loading Hall Of Fame photo',
    viewLiveMap: 'View Live Map',
    lastUpdatedAt: 'Last updated at',
    sparkClosestStrike: 'Closest strike in the last 30 minutes:',
    away: 'away',
    sparkLightning: 'SPARK LIGHTNING',
    predominantPollen: 'Predominant Pollen',
    backToTop: 'Back to top',
    failedToLoadSitemap: 'Failed to load sitemap',
    cities: 'cities',
    states: 'states',
    countries: 'countries',
    in: 'in',
    press: 'Press',
    latestNewsAndAnnouncements: 'Latest News and Announcements',
    backToPress: 'Back to Press',
    checkNetworkConnectivity: 'Check your network connectivity and try to reload your page',
    pressArticleImageAltText: 'Press article image',
    general: 'General',
    android: 'Android',
    ios: 'iOS',
    website: 'Website',
    others: 'Other',
    questions: 'Questions',
    weather: 'Weather',
    precip: 'Precip',
    next12Hours: 'Next 12 Hours',
    temp: 'Temp',
    faq: 'FAQ',
    night: 'Night',
    day: 'Day',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    tonight: 'Tonight',
    hourly: 'Hourly',
    details: 'Details',
    tenDayForecast: '10 Day Forecast',
    now: 'Now',
    tenDay: '10 Day',
    share: 'share',
    upload: 'upload',
    photos: 'photos',
    precipitation: 'Precipitation',
    advertisement: 'Advertisement',
    conditions: 'Conditions',
    snowice: 'Snow/Ice',
    wet: 'Wet',
    slush: 'Slush',
    roadConditions: 'Road conditions',
    wetRoadsDescription: 'Some roads will be wet',
    slushyRoadDescription: 'Some roads will be slushy',
    icySnowRoadDescription: 'Some roads will be icy',
    failedToLoad: 'Failed to load',
    dataLoadErrorMessage: 'Something went wrong loading the data. Please reload the page or try again later',
    allAlertsListName: 'All Alerts',
    allNoAlertsTitle: 'Enjoy the Weather',
    allNoAlertsMessage:'There are no alerts in your area.',
    weatherAlertsListName: 'Weather',
    weatherNoAlertsTitle: 'No Weather Alerts',
    weatherNoAlertsMessage: 'There are no Weather alerts in your area.',
    lightningListName: 'Lightning',
    lightningNoAlertsTitle: 'No Spark Alerts',
    lightningNoAlertsMessage: 'There are no Spark alerts in your area.',
    hurricaneListName: 'Hurricane',
    hurricaneNoAlertsTitle: 'No Hurricane Alerts',
    hurricaneNoAlertsMessage: 'There are no Hurricane alerts in your area.',
    fireListName: 'Fire',
    fireNoAlertsTitle: 'No Fire Alerts',
    fireNoALertsMessage: 'There are no Fire alerts in your area.',
    pollenListName: 'Pollen',
    pollenNoAlertsTitle: 'No Pollen Alerts',
    pollenNoAlertsMessage: 'There are no Pollen alerts in your area.',
    airQualityListName: 'Air Quality',
    airQualityNoAlertsTitle: 'No Air Quality Alerts',
    airQualityNoAlertsMessage: 'There are no Air Quality alerts in your area.',
    severeStormRiskListName: 'Severe Storm Risk',
    severeStormRiskNoAlertsTitle: 'No Severe Storm Risk Alerts',
    severeStormRiskNoALertsMessage: 'There are no Severe Storm Risk alerts in your area.',
    commuterListName: 'Commuter',
    forMediaInquiries: 'For media inquiries, please contact',
    alertDataLoadError: 'Something went wrong loading the data. Please reload the page or try again later',
    excellent: 'Excellent',
    fair: 'Fair',
    poor: 'Poor',
    topTriggers: 'Top Triggers',
    aqiPopupHeaderText: 'Air Quality Index',
    healthAdvice: 'Health Advice',
    lungAndHeartDisease: 'Lung & Heart Disease',
    children: 'Children',
    active: 'Active',
    sponsoredBy: 'Sponsored By',
    daysAgo: 'days ago',
    noDataAvailable: 'No Data Available',
    noDataInLocationMessage: 'The data is not available in your area.',
    pollenDataNotAvailable: 'Data not available for this location.',
    unitedStates: 'United States',
    andThen: 'and then',
    airYouBreatheDataProvidedBy: 'Air quality data provided by Ambee',
    outdoorSports: 'Outdoor Sports',
    todaysWeather: 'Today\'s Weather',
    hourlyForecast: 'Hourly Forecast',
    tenDayWeather: '10 Day Weather',
    weatherAlertsNational: 'Weather Alerts',
    weatherAlertsLocalized: 'Weather Alerts For',
    sparkAlertsNational: 'Lightning Strike Map',
    sparkAlertsLocalized: 'Lightning Strike Map in',
    hurricaneAlertsNational: 'Hurricane Forecast',
    hurricaneAlertsLocalized: 'Hurricane Forecast for',
    fireAlertsNational: 'Local Fire Updates',
    fireAlertsLocalized: 'Fire Updates For',
    severestormriskAlertsNational: 'Severe Storm Risk',
    severestormriskAlertsLocalized: 'Severe Storm Risk -',
    airqualityAlertsNational: 'Air Quality Index',
    airqualityAlertsLocalized: 'Air Quality in',
    outdoorSportsFor: 'Forecast for',
    outdoorSportsGuideFor: 'Outdoor Sports Guide for',
    safetyTips: 'Safety Tips',
    keyIndicators: 'Key Indicators',
    precipProb: 'Precip Prob',
    uv: ' UV',
    wetBulb: 'Wet Bulb Globe Temp',
    hourlyChart: 'Hourly Chart',
    limitUseOfMySensitivePersonalPersonalInformation: 'Limit the Use of My Sensitive Personal Information',
    personalInfomationIsLimited: 'Personal Information is Limited',
    hourlyOutdoorIndex: 'Hourly Outdoor Index',
    dataLoadFirstErrorMessage: 'Something went wrong loading the data.',
    dataLoadSecondErrorMessage: 'Please reload the page or try again later.',
    outdoorSportsStories: 'Outdoor Sports Stories',
    outdoorSportsIndex: 'Outdoor Sports Index',
    fireCenter: 'Fire Center',
    liveRadar: 'Live Weather Radar',
    tomorrow: 'Tomorrow',
    weatherForecast: 'WEATHER FORECAST',
    weatherCameras: 'Weather Cameras',
    weatherRadarMap: 'Weather Radar Map',
    localFireMap: 'Local Fire Map',
    weatherForecastMaps: 'Weather Forecast Maps',
    map: 'Map',
    hurricaneAlertsMap: 'Hurricane Alerts Map',
    sparkLightningAlertsMap: 'Spark/Lightning Alerts Map',
    snowSkiMap: 'Snow Ski Map',
    weatherTrafficCamerasMap: 'Weather Traffic Cameras Map',
    lightningMap: 'Lightning Map',
    fireUpdates: 'Fire Updates',
    trafficCameras: 'Traffic Cameras',
    pollenCountAndAllergyForecast: 'POLLEN COUNT & ALLERGY FORECAST',
    refreshData: 'Refresh Data',
    pleaseRefresh: 'Please refresh the page to get updated data.',
    refresh: 'Refresh',
    noActiveHurricaneOrWarningIssued: 'No Active Hurricanes or Warnings Issued',
    hurricaneMap: 'Hurricane Map',
    hurricaneNational: 'Hurricane Tracker',
    hurricaneLocalized: 'Hurricane Tracker for',
    activeHurricane: 'Active Hurricane',
    hurricaneOutlook: 'Outlook',
    noActiveHurricanes: 'No Active Hurricanes',
    gust: 'Gust',
    fromYourLocation: 'From your location',
    coordinates: 'Coordinates',
    forwardWind: 'Forward Wind',
    hurricaneCategory: 'Hurricane Category',
    tropicalDepression: 'Tropical Depression',
    tropicalStorm: 'Tropical Storm',
    category: 'Category',
    noEvent: 'No Event',
    activeEvent: 'Active Event',
    event: 'Event',
    events: 'Events',
    dataNotAvailable: 'Data not available. Try again later.',
    checkOutlookDetailsForMoreInfo: 'Check outlook details for more information',
    webcam: 'Webcam',
    trafficCamera: 'Traffic Camera',
    weatherBugAdsForAdvertisers: 'WeatherBug for Advertisers',
    usStatePrivacyRights: 'U.S. States Privacy Rights',
    currentCondition: 'Current Condition'
};

export const alertRoutes = {
    allAlerts: 'alerts',
    weatherAlerts: 'alerts/weather',
    sparkAlerts: 'alerts/spark',
    hurricaneAlerts: 'alerts/hurricane',
    fireAlerts: 'alerts/fire',
    pollenAlerts: 'alerts/pollen',
    airQualityAlerts: 'alerts/air-quality',
    severeStormRiskAlerts: 'alerts/severe-storm-risk',
    commuterAlerts: 'alerts/commuter'
};
export const alertPageIds = {
    allAlerts: 'alerts',
    weatherAlerts: 'alerts/weather',
    sparkAlerts: 'alerts/spark',
    hurricaneAlerts: 'alerts/hurricane',
    fireAlerts: 'alerts/fire',
    pollenAlerts: 'alerts/pollen',
    airQualityAlerts: 'alerts/airquality',
    severeStormRiskAlerts: 'alerts/severestormrisk',
    commuterAlerts: 'alerts/commuter'
};

export const faqRoutes = {
    faq: 'faq',
    general: 'faq/general',
    android: 'faq/android',
    ios: 'faq/ios',
    website: 'faq/website',
    others: 'faq/others',
    accountDeletion: 'faq/accountdeletion'
};

export const forecastRoutes = {
    now: '/weather-forecast/now/',
    hourly: '/weather-forecast/hourly/',
    tenDay: '/weather-forecast/10-day-weather/'
};

export const topStoriesNewsRoutes = {
    news: '/news/',
    linkToStoriesPage: '/news/?page=top'
};

export const newsRoutes = {
    news: 'news'
};

export const aqiRoute = {
    airquality: 'air-quality'
};

export const hurricaneRoute = {
    hurricane: 'hurricane'
};

export const lifeRoutes = {
    lifeColdFlu: 'life/cold-flu',
    lifePollen: 'life/pollen',
    lifeOutdoorSports: 'life/outdoor-sports'
};

export const storyLegacyRoutes = {
    lifePollenStory: 'life/pollen/story',
    lifeColdFluStory: 'life/coldflu/story',
    hurricaneStory: 'hurricane/story'
};

export const footerNavigationLinks = [
    {
        label: 'Terms',
        id: 'termsOfUse',
        type: 'legal',
        url: '/legal/terms',
        target: '_self',
        orderLarge: 0,
        orderSmall: 0,
        orderOnLargeWhenNoPMLink: 0,
        orderOnSmallWhenNoPMLink: 0
    },
    {
        label: 'Privacy',
        id: 'privacyPolicy',
        type: 'legal',
        url: '/legal/privacy',
        target: '_self',
        orderLarge: 2,
        orderSmall: 1,
        orderOnLargeWhenNoPMLink: 2,
        orderOnSmallWhenNoPMLink: 1
    },
    {
        label: 'Your Privacy Choices',
        id: 'privacyManagerLink',
        type: 'legal',
        url: '#',
        target: '_self',
        orderLarge: 4,
        orderSmall: 2,
        orderOnLargeWhenNoPMLink: -1, // ignore
        orderOnSmallWhenNoPMLink: -1 // ignore
    },
    {
        label: 'Partners',
        id: 'partners',
        type: 'legal',
        url: '/partners',
        target: '_self',
        orderLarge: 6,
        orderSmall: 3,
        orderOnLargeWhenNoPMLink: 4,
        orderOnSmallWhenNoPMLink: 2
    },
    {
        label: 'Ad Choices',
        id: 'adchoices',
        type: 'legal',
        url: '/legal/privacy#AC',
        target: '_self',
        orderLarge: 8,
        orderSmall: 4,
        orderOnLargeWhenNoPMLink: 6,
        orderOnSmallWhenNoPMLink: 3
    },
    {
        label: 'Sitemap',
        id: 'sitemap',
        type: 'additionalLink',
        url: '/sitemap/',
        target: '_self',
        orderLarge: 1,
        orderSmall: 5,
        orderOnLargeWhenNoPMLink: 1,
        orderOnSmallWhenNoPMLink: 4
    },
    {
        label: 'USA',
        id: 'sitemapusa',
        type: 'additionalLink',
        url: '/sitemap/North-America/United-States/states',
        target: '_self',
        orderLarge: 3,
        orderSmall: 6,
        orderOnLargeWhenNoPMLink: 3,
        orderOnSmallWhenNoPMLink: 5
    },
    {
        label: 'FAQ',
        id: 'faq',
        type: 'additionalLink',
        url: '/faq/',
        target: '_self',
        orderLarge: 5,
        orderSmall: 7,
        orderOnLargeWhenNoPMLink: 5,
        orderOnSmallWhenNoPMLink: 6
    },
    {
        label: 'WeatherBug for Advertisers',
        id: 'wbForAdvertisers',
        type: 'additionalLink',
        url: 'https://ads.weatherbug.com/',
        target: '_blank',
        orderLarge: 7,
        orderSmall: 8,
        orderOnLargeWhenNoPMLink: 7,
        orderOnSmallWhenNoPMLink: 7
    }
];

export const footerDeviceStores = [
    {
        storeAriaLabel: 'Click to download WeatherBug on the App Store',
        storeLink: 'https://itunes.apple.com/us/app/weatherbug-radar-forecast/id281940292?ls=1&mt=8',
        storeImageSrc: '/images/footer/stores/apple/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
    },
    {
        storeAriaLabel: 'Click to download WeatherBug on the Google Play Store',
        storeLink: 'https://play.google.com/store/apps/details?id=com.aws.android',
        storeImageSrc: '/images/footer/stores/google/google-play-badge.png'
    }
];

const mapsBaseUrl = '/maps';
const layerId = '?layerId=';

export const sitemap = {
    name: 'Sitemap',
    path: '/sitemap'
};

export const sitemapTitles = {
    locations: 'LOCATIONS',
    forecasts: 'FORECASTS',
    maps: 'MAPS',
    alerts: 'ALERTS',
    lifestyles:'LIFESTYLES',
    news: 'NEWS',
    cameras: 'CAMERAS',
    company: 'COMPANY'
};

export const continents = [
    {
        name: 'North America',
        path: sitemap.path + '/North-America'
    },
    {
        name: 'South America',
        path: sitemap.path + '/South-America'
    },
    {
        name: 'Africa',
        path: sitemap.path + '/Africa'
    },
    {
        name: 'Europe',
        path: sitemap.path + '/Europe'
    },
    {
        name: 'Asia',
        path: sitemap.path + '/Asia'
    },
    {
        name: 'Australia',
        path: sitemap.path + '/Australia'
    }
];

export const forecasts = [
    {
        name: 'Now',
        path: '/weather-forecast/now/'
    },
    {
        name: 'Hourly',
        path: '/weather-forecast/hourly/'
    },
    {
        name: '10 Day',
        path: '/weather-forecast/10-day-weather/'
    }
];

export const maps = [
    {
        name:'Storm Tracker',
        path: mapsBaseUrl + layerId + 'stormtracker'
    },
    {
        name:'Global Radar',
        path: mapsBaseUrl + layerId + 'radar'
    },
    {
        name:'Air Quality',
        path: mapsBaseUrl + layerId + 'airquality'
    },
    {
        name:'Pollen',
        path: mapsBaseUrl + layerId + 'pollen'
    },
    {
        name:'Worldwide Satellite',
        path: mapsBaseUrl + layerId + 'satellite'
    },
    {
        name:'Alerts',
        path: mapsBaseUrl + layerId + 'dta:nws'
    },
    {
        name:'Lightning',
        path: mapsBaseUrl + layerId + 'xflash-consumer'
    },
    {
        name:'Precipitation',
        path: mapsBaseUrl + layerId + 'precipitation'
    },
    {
        name:'Temperature',
        path: mapsBaseUrl + layerId + 'temperature'
    },
    {
        name:'Local Temperature',
        path: mapsBaseUrl + layerId + 'Observed.Temperature.English'
    },
    {
        name:'Pressure',
        path: mapsBaseUrl + layerId + 'pressure'
    },
    {
        name:'Local Pressure',
        path: mapsBaseUrl + layerId + 'Observed.Pressure.SeaLevel.English'
    },
    {
        name:'Heat Index',
        path: mapsBaseUrl + layerId + 'heatindex'
    },
    {
        name:'Wind Chill',
        path: mapsBaseUrl + layerId + 'windchill'
    },
    {
        name:'Humidity',
        path: mapsBaseUrl + layerId + 'humidity'
    },
    {
        name:'Wind Speed',
        path: mapsBaseUrl + layerId + 'windspeed'
    },
    {
        name:'Dew Point',
        path: mapsBaseUrl + layerId + 'dewpoint'
    }
];

export const alerts = [
    {
        name: 'Alerts',
        path: '/alerts'
    },
    {
        name: 'Weather',
        path: '/alerts/weather'
    },
    {
        name: 'Spark',
        path: '/alerts/spark'
    },
    {
        name: 'Hurricane',
        path: '/alerts/hurricane/'
    },
    {
        name: 'Fire',
        path: 'alerts/fire/'
    },
    {
        name: 'Pollen',
        path: '/alerts/pollen'
    },
    {
        name: 'Air Quality',
        path: '/alerts/air-quality'
    },
    {
        name: 'Severe Storm Risk',
        path: '/alerts/severe-storm-risk'
    }
];

export const lifestyles = [
    {
        name: 'Allergies & Pollen',
        path: '/life/pollen/'
    },
    {
        name: 'Cold & Flu',
        path: '/life/cold-flu/'
    },
    {
        name: 'Outdoor Sports',
        path: '/life/outdoor-sports/'
    },
    {
        name: 'Snow & Ski',
        path: '/life/snow-ski/'
    },
    {
        name: 'Travel',
        path: '/life/travel/'
    },
    {
        name: 'Air Quality',
        path: '/air-quality'
    }
];

export const news = [
    {
        name: 'Top News Stories',
        path: '/news/'
    },
    {
        name: 'Weather Videos',
        path: '/weather-videos/'
    }
];

export const cameras = [
    {
        name: 'Local Weather Cameras',
        path: '/weather-camera/'
    },
    {
        name: 'Beach Cams',
        path: '/weather-camera-beach-cams'
    },
    {
        name: 'City Skyline Cams',
        path: '/weather-camera-city-skylines'
    },
    {
        name: 'Mountain Cams',
        path: '/weather-camera-mountain-cams'
    },
    {
        name: 'Stadium Cams',
        path: '/weather-camera-stadium-cams'
    },
    {
        name: 'Cool Spot Cams',
        path: '/weather-camera-cool-spots'
    },
    {
        name: 'Traffic Cameras',
        path: '/traffic-cam/'
    }
];

export const camerasPagesOnWeb2 = [
    {
        name: 'Local Weather Cameras',
        path: '/weather-camera'
    },
    {
        name: 'Beach Cams',
        path: '/weather-camera/categories/beach-cams'
    },
    {
        name: 'City Skyline Cams',
        path: '/weather-camera/categories/city-skylines'
    },
    {
        name: 'Mountain Cams',
        path: '/weather-camera/categories/mountain-cams'
    },
    {
        name: 'Stadium Cams',
        path: '/weather-camera/categories/stadium-cams'
    },
    {
        name: 'Cool Spot Cams',
        path: '/weather-camera/categories/cool-spots'
    },
    {
        name: 'Traffic Cameras',
        path: '/traffic-cam'
    }
];

export const company = [
    {
        name: 'Press',
        path: '/press/'
    },
    {
        name: 'Education',
        path: '/education/'
    },
    {
        name: 'Careers',
        path: 'https://www.groundtruth.com/jobs/?job-company=4780'
    },
    {
        name: 'FAQ',
        path: '/faq/'
    }
];

const unitedStatesBase = '/North-America/United-States/state';

export const unitedStates = [
    {
        path: `${sitemap.path}${unitedStatesBase}/Alabama/AL`,
        name: 'Alabama'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Alaska/AK`,
        name: 'Alaska'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Arizona/AZ`,
        name: 'Arizona'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Arkansas/AR`,
        name: 'Arkansas'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/California/CA`,
        name: 'California'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Colorado/CO`,
        name: 'Colorado'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Connecticut/CT`,
        name: 'Connecticut'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Delaware/DE`,
        name: 'Delaware'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Florida/FL`,
        name: 'Florida'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Georgia/GA`,
        name: 'Georgia'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Hawaii/HI`,
        name: 'Hawaii'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Idaho/ID`,
        name: 'Idaho'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Illinois/IL`,
        name: 'Illinois'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Indiana/IN`,
        name: 'Indiana'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Iowa/IA`,
        name: 'Iowa'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Kansas/KS`,
        name: 'Kansas'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Kentucky/KY`,
        name: 'Kentucky'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Louisiana/LA`,
        name: 'Louisiana'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Maine/ME`,
        name: 'Maine'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Maryland/MD`,
        name: 'Maryland'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Massachusetts/MA`,
        name: 'Massachusetts'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Michigan/MI`,
        name: 'Michigan'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Minnesota/MN`,
        name: 'Minnesota'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Mississippi/MS`,
        name: 'Mississippi'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Missouri/MO`,
        name: 'Missouri'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Montana/MT`,
        name: 'Montana'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Nebraska/NE`,
        name: 'Nebraska'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Nevada/NV`,
        name: 'Nevada'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/New-Hampshire/NH`,
        name: 'New Hampshire'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/New-Jersey/NJ`,
        name: 'New Jersey'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/New-Mexico/NM`,
        name: 'New Mexico'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/New-York/NY`,
        name: 'New York'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/North-Carolina/NC`,
        name: 'North Carolina'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/North-Dakota/ND`,
        name: 'North Dakota'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Ohio/OH`,
        name: 'Ohio'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Oklahoma/OK`,
        name: 'Oklahoma'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Oregon/OR`,
        name: 'Oregon'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Pennsylvania/PA`,
        name: 'Pennsylvania'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Rhode-Island/RI`,
        name: 'Rhode Island'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/South-Carolina/SC`,
        name: 'South Carolina'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/South-Dakota/SD`,
        name: 'South Dakota'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Tennessee/TN`,
        name: 'Tennessee'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Texas/TX`,
        name: 'Texas'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Utah/UT`,
        name: 'Utah'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Vermont/VT`,
        name: 'Vermont'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Virginia/VA`,
        name: 'Virginia'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Washington/WA`,
        name: 'Washington'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/West-Virginia/WV`,
        name: 'West Virginia'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Wisconsin/WI`,
        name: 'Wisconsin'
    },
    {
        path: `${sitemap.path}${unitedStatesBase}/Wyoming/WY`,
        name: 'Wyoming'
    }
];
